export default "__VITE_ASSET__14e30743__"